import { isDev } from '../../env';
import { defineFeatureFlag } from '../types';

const USER_IDS: number[] = isDev() ? [793] : [914, 840, 35];

export const chatNewDesign = defineFeatureFlag({
  description: 'Новый дизайн чата поддержки',
  removedBy: null,
  optIn: true,
  enabled: ctx => ctx.userId !== null && USER_IDS.includes(ctx.userId)
});
